import React from "react";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_GURU } from "@/lib/nav";
import KalenderPendidikan from "@/components/KalenderPendidikan";

export default function KalenderPendidikanGuru() {
  return (
    <Layout nav={NAV_GURU}>
      <PageTitle title="Kalender Pendidikan" />
      <KalenderPendidikan />
    </Layout>
  );
}
